import {
  Breakpoints,
  NewCarPrivate,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';
import React from 'react';
import { useFeatureAppConfig } from '../../hooks/use-feature-app-config';
import { useMaintenanceContext } from '../../hooks/use-maintenance-context';
import { StyledContainer, StyledFormDescription } from './styled';

export const SectionHeader = () => {
  const { translationHandler } = useMaintenanceContext();
  const { mode } = useFeatureAppConfig();
  const lightTitle =
    mode === 'maintenance'
      ? 'form.maintenance.title.recommended'
      : 'form.literature.title.find';
  const strongTitle =
    mode === 'maintenance'
      ? 'form.maintenance.title.schedule'
      : 'form.literature.title.owner';

  return (
    <StyledContainer>
      <TextCustom
        appearance={TextAppearance.headline400}
        style={{
          [Breakpoints.default]: {
            fontWeight: TextWeight.light,
            fontSize: TextSize.TextSize32,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
          [Breakpoints.b560]: {
            fontWeight: TextWeight.light,
            fontSize: TextSize.TextSize48,
            lineHeight: TextLineHeight.TextLineHeight56,
          },
        }}
      >
        {translationHandler(lightTitle)}{' '}
        <TextCustom
          appearance={TextAppearance.headline400}
          style={{
            [Breakpoints.default]: {
              fontWeight: TextWeight.bold,
              fontSize: TextSize.TextSize32,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
            [Breakpoints.b560]: {
              fontWeight: TextWeight.bold,
              fontSize: TextSize.TextSize48,
              lineHeight: TextLineHeight.TextLineHeight56,
            },
          }}
        >
          {translationHandler(strongTitle)}
        </TextCustom>
      </TextCustom>
      <StyledFormDescription>
        <NewCarPrivate />
        <TextCustom
          appearance={TextAppearance.headline200}
          style={{
            [Breakpoints.default]: {
              fontWeight: TextWeight.light,
              fontSize: TextSize.TextSize20,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
            [Breakpoints.b560]: {
              fontWeight: TextWeight.light,
              fontSize: TextSize.TextSize24,
              lineHeight: TextLineHeight.TextLineHeight28,
            },
          }}
        >
          {translationHandler('form.subtitle')}
        </TextCustom>
      </StyledFormDescription>
    </StyledContainer>
  );
};
